{
  "el": {
    "space": {
      "actions": {
        "assignOtherUnit": "Ανάθεση σε άλλο ακίνητο",
        "assignSpace": "Ανάθεση βοηθητικού χώρου",
        "assignUnit": "Ανάθεση σε ακίνητο",
        "cancel": "Αναίρεση",
        "closeEdit": "Κλείσιμο επεξεργασίας",
        "create_space": "Δημιουργία βοηθητικού χώρου",
        "delete": "Αφαίρεση",
        "edit": "Επεξεργασία",
        "goToSpaces": "Δημιουργία νέων βοηθητικών χώρων",
        "new": "Βοηθητικός χώρος",
        "save": "Αποθήκευση",
        "unassign": "Κατάργηση ανάθεσης ακινήτου",
        "unassignSpaces": "Κατάργηση ανάθεσης βοηθητικών χώρων"
      },
      "attributes": {
        "category": "Τύπος",
        "description": "Περιγραφή",
        "level": "Επίπεδο",
        "name": "Όνομα",
        "price_value": "Συνολική αξία πώλησης",
        "price_value_construction": "Αξία κατασκευής",
        "price_value_land": "Αξία οικοπέδου",
        "quotity": "Μερίδιο ποσού μεταβίβασης",
        "status": "Κατάσταση",
        "unit": "Ακίνητο"
      },
      "category": {
        "bicyclestorage": "Αποθήκη ποδηλάτων",
        "cellar": "Υπόγειο",
        "garagebox": "Κλειστό γκαράζ",
        "other": "Άλλο",
        "outdoor_space": "Εξωτερικός χώρος",
        "parkinglot": "Θέση στάθμευσης",
        "storage": "Γενική αποθήκη",
        "winecellar": "Κάβα κρασιών"
      },
      "labels": {
        "allSpacesAssigned": "Όλοι οι βοηθητικοί χώροι έχουν ανατεθεί σε ακίνητο.",
        "assignedSpaces": "Ανατεθειμένοι βοηθητικοί χώροι",
        "internal": "Εσωτερικά",
        "noCategory": "Δεν έχει οριστεί τύπος",
        "noSpaceAssigned": "Δεν έχουν ανατεθεί βοηθητικοί χώροι",
        "noSpaces": "Δεν έχουν δημιουργηθεί ακόμη βοηθητικοί χώροι",
        "notAssignedToUnit": "Δεν έχει ανατεθεί ακίνητο",
        "onlyAvailableSpacesShown": "Εμφανίζονται μόνο οι διαθέσιμοι βοηθητικοί χώροι",
        "selectToUnassign": "Επίλεξε για κατάργηση ανάθεσης",
        "space": "Βοηθητικός χώρος",
        "spaces": "Βοηθητικοί χώροι",
        "spacesProject": "Βοηθητικοί χώροι στο έργο {project}",
        "unassignedSpaces": "Μη ανατεθειμένοι βοηθητικοί χώροι"
      },
      "validation": {
        "needCategory": "Ο τύπος είναι υποχρεωτικός",
        "needName": "Απαιτείται όνομα",
        "needNumber": "Πρέπει να είναι αριθμός (π.χ. 95)",
        "selectSpace": "Επίλεξε τουλάχιστον 1 βοηθητικό χώρο"
      }
    }
  }
}
